import Segmented from "rc-segmented";
import React from "react";
import "rc-segmented/assets/index.css";
import "./custom-segment.scss";

export default function CusSegment({ value, options, onChange, className }) {
  return <Segmented className={className} value={value} options={options} onChange={onChange} />;
}
